// Import React Components
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from "react-router-dom";

// Import Material UI Elements
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";

// Import CSS Files
import './settings.css';

// Import Data
import {SIDE_NAV_SETTINGS} from "../../../services/MockData";

// Import State Management
import {useRecoilState} from 'recoil';
import {activeSideBarMenu} from '../../../recoil-store/recoil-state';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

function Settings(props) {
    const [selected, setSelected] = useState(0);
    const [asmTemp, setAsmTemp] = useState({});
    const navigate = useNavigate();
    const classes = useStyles();
    const {t} = useTranslation();

    useEffect(() => {
        if (props.asm) setAsmTemp(JSON.parse(JSON.stringify(props.asm)));
        if (props.asm?.child && props.asm?.parent === SIDE_NAV_SETTINGS.order) setSelected(props.asm.child);
        else setSelected(SIDE_NAV_SETTINGS.thirdLevelItems[0].order);
    }, []);

    const navigateUser = (to, child, parent) => {
        if (to) {
            asmTemp.child = child;
            asmTemp.parent = parent;
            setAsmTemp(asmTemp);
            setSelected(child);
            navigate(to);
        }
    }

    return (
        <Grid container className={classes.root} spacing={2}>
            <Grid item xs={12} sm={3} md={2}>
                <Grid key={0} item>
                    <div className="third-level-menu">
                        <h5 className="tlm-header">Menu</h5>
                        {SIDE_NAV_SETTINGS.thirdLevelItems.map((item, index) => {
                            return (
                                <div key={index} className="third-level-menu-item-row">
                                    <div
                                        className={`third-level-menu-item ${selected === item.order || asmTemp?.child === item.order ? "active-menu" : ""}`}
                                        onClick={() => navigateUser(item.to, item.order, SIDE_NAV_SETTINGS.order)}>
                                        {t(item.label)}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={9} md={10}>
                <Grid key={1}>
                    {props.directTo}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Settings;
